<template>
      <v-col>
          <v-card flat>
         <v-data-table
            :key="componentKey"
            :headers="computedHeaders"
            :items="tableItems"
            class="elevation-1"
            :loading="usersLoadStatus===1"
            :options.sync="tableOptions"
            :server-items-length="options.lineCount"
            hide-default-footer
            must-sort
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title>Użytkownicy</v-toolbar-title>
                
                <v-divider
                  class="mx-4"
                  inset
                  vertical
                ></v-divider>
                

                <v-tooltip right>
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-on="on"
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="Wyszukaj"
                      single-line
                      hide-details
                      class="search"
                      @keydown.enter="searchUsers"
                  ></v-text-field>
                  </template>
                    <span>Wpisz min 3 znaki i naciśnij Enter</span>
                </v-tooltip>
                 

                <v-spacer></v-spacer>

                <v-checkbox v-model="showDeleted" class="mt-4" label="Pokaż wyłączone"></v-checkbox>

                <v-divider
                  v-if="user.permissions['user'] >= 10"
                  class="mx-4"
                  inset
                  vertical
                ></v-divider>

                <v-tooltip v-if="user.permissions['user'] >= 10" right>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" :to="{name:'ustawienia.uzytkownik',params:{}}" fab dark small><v-icon>mdi-plus</v-icon></v-btn>
                  </template>
                    <span>Dodaj rekord</span>
                </v-tooltip>

                <v-dialog v-model="dialogPassword" max-width="500px">
                  <user-password-editor @close="closePassword" />
                </v-dialog>
              </v-toolbar>
            </template>
            <template v-slot:item.color="{ item }">
              <v-icon :color="item.color">mdi-checkbox-blank</v-icon>
            </template>
            <template v-slot:item.actions="{ item }">

                <v-tooltip v-if="item.status && user.permissions['user'] >= 10" right>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" :to="{name:'ustawienia.uzytkownik',params:{id:item.id}}" icon><v-icon>mdi-pencil</v-icon></v-btn>
                  </template>
                    <span>Edytuj</span>
                </v-tooltip>

                <v-tooltip v-if="item.status && user.permissions['user'] >= 10" right>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" @click="editItemPassword(item)" icon><v-icon>mdi-key</v-icon></v-btn>
                  </template>
                    <span>Zmień hasło</span>
                </v-tooltip>

                <v-tooltip v-if="item.status && item.can_delete && user.permissions['user'] >= 10" right>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" @click="deleteItem(item)" icon><v-icon>mdi-delete</v-icon></v-btn>
                  </template>
                  <span>Wyłącz</span>
                </v-tooltip>

                <v-tooltip v-if="!item.status  && user.permissions['user'] >= 10" right>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" @click="reactivateItem(item)" icon><v-icon>mdi-delete-restore</v-icon></v-btn>
                  </template>
                  <span>Przywróć</span>
                </v-tooltip>

                <v-tooltip v-if="!item.status && item.can_delete  && user.permissions['user'] >= 10" right>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" @click="forceDeleteItem(item)" icon><v-icon color="error">mdi-delete-forever</v-icon></v-btn>
                  </template>
                  <span>Usuń na stałe</span>
                </v-tooltip>

                
            </template>

            <template v-slot:item.status="{ item }">
              <v-simple-checkbox v-model="item.status" disabled></v-simple-checkbox>
            </template>

          </v-data-table> 
          <div class="text-center pt-2">
            <v-btn @click="loadMore" v-if="!options.itemAdded && options.lineCount-tableItems.length>0 && usersLoadStatus===2" small color="primary"><v-icon left>mdi-download</v-icon>Załaduj więcej ({{ options.lineCount-tableItems.length }})</v-btn>
            <v-btn @click="loadUsers" v-else-if="options.itemAdded && options.lineCount-tableItems.length>0" small color="primary"><v-icon left>mdi-reload</v-icon>Odśwież tabele aby móc załadować więcej ({{ options.lineCount-tableItems.length }})</v-btn>
            <v-btn @click="loadUsers" v-else-if="options.itemSearched" small color="primary"><v-icon left>mdi-reload</v-icon>Anuluj wyszukiwanie</v-btn>
          
          </div>

          </v-card>
      
      <confirm ref="confirm"></confirm>
      </v-col>
      

</template>

<script>
  import confirm from '../components/Confirm'
  import UserPasswordEditor from '../components/editors/UserPasswordEditor'
  import {Helper} from '../mixins/helper'

  export default {
    mixins:[
      Helper
    ],
    props:{
      reload: Boolean
    },
    components:{
      confirm,
      UserPasswordEditor
    },
    data: () => ({
      componentKey:0,
      tableOptions: {},
      dialogPassword: false,
      search:'',
      headers: [
        { text: '',align: 'start',sortable: false,value: 'lp',filterable:false,visible:true},
        { text: '',sortable: false,value: 'color',filterable:false,visible:true,width:'50'},
        { text: 'Login', value: 'login',filterable:true,filterColumn:"login",visible:true },
        { text: 'Imię', value: 'name',filterable:true,filterColumn:"name",visible:true },
        { text: 'Nazwisko', value: 'surname',filterable:true,filterColumn:"surname",visible:true },
        { text: 'Rola', value: 'role.name',sortable: false,filterable:true,filterColumn:"role.name",visible:true },
        { text: 'Ostatnie logowanie', value: 'last_login',filterable:true,filterColumn:"last_login",visible:true },
        { text: 'Status', value: 'status', sortable: false,filterable:false ,visible:true },
        { text: '', value: 'actions', sortable: false,filterable:false,visible:true },
      ],
    }),
    watch: {
      tableOptions: {
        handler () {
          var currentOptions = {...this.options};
          const { sortBy, sortDesc } = this.tableOptions
        
          //zmiana sortowania
          if (sortBy.length === 1 && sortDesc.length === 1) {
            currentOptions.orderBy = sortBy[0];
            currentOptions.orderDirection = sortDesc[0]?'desc':'asc';
            this.options = currentOptions;
          } 
        },
        deep: true,
      },
      userEditStatus(val){
        if(val===2){
          this.componentKey += 1;
        }
      },
      userAddStatus(val){
        if(val===2){
          this.componentKey += 1;
        }
      },
      userDeleteStatus(val){
        if(val===2){
          this.componentKey += 1;
        }
      }
    },
    computed: {
      user(){
        return this.$store.getters.getUser;
      },
      lookups(){
        return this.$store.getters.getLookups;
      },
      options:{
        get () {  
          return this.$store.getters.getUserOptions;
        },
        set (value) {
          this.search='';
          this.$store.dispatch( 'setUserOptions', {options:value} )
        }
      },
      showDeleted: {
        get () {
          return this.$store.getters.getUserOptions.showDeleted;
        },
        set (value) {
          var currentOptions = {...this.options};
          currentOptions.showDeleted = value;
          this.options = currentOptions;
        }
      },
      editedItem(){
        return this.$store.getters.getUserEdit;
      },
      tableItems(){
        return this.$store.getters.getUsers;
      },
      usersLoadStatus(){
        return this.$store.getters.getUsersLoadStatus;
      },
      userEditLoadStatus(){
        return this.$store.getters.getUserEditLoadStatus
      },
      userEditStatus(){
        return this.$store.getters.getUserEditStatus();
      },
      userAddStatus(){
        return this.$store.getters.getUserAddStatus();
      },
      userDeleteStatus(){
        return this.$store.getters.getUserDeleteStatus();
      },
      computedHeaders () {
        var h = _.filter(this.headers,function(o) { return o.visible; })

        //if(!this.showDeleted && this.user.permissions['user'] == 0) return h.filter(h => h.value!=='status' && h.value!=='actions')
        //else if(this.showDeleted && this.user.permissions['user'] <= 5) return h.filter(h => h.value!=='actions')
        //else 
        if(!this.showDeleted) return h.filter(h => h.value!=='status')
        else return h
      },
    },
    mounted(){
      if(this.lookups.roles.length>0){
        this.loadUsers();
      }else{
        this.$store.dispatch( 'loadLookups' );
        setTimeout(() => {
          this.loadUsers();
        }, 2000)
      }
    },
    methods: {
      loadUsers(){
        this.search='';
        if(this.reload)this.$store.dispatch( 'loadUsers' );
      },
      loadMore(){
        this.$store.dispatch( 'loadMoreUsers' );
      },
      editItemPassword (item) {  
        //this.itemEditingPassword = true
        this.editedItem.id = item.id
        this.editedItem.password = this.randPasswordString();
        this.dialogPassword = true
      },
      reactivateItem(item){
        this.$store.dispatch( 'editUserReactivate',{slug:item.id});
      },
      deleteItem (item) {
        this.$refs.confirm.open('Usuń', 'Czy na pewno chcesz wyłączyć użytkownika?', { color: 'error' }).then((confirm) => {
            if(confirm){
               this.$store.dispatch( 'deleteUser', {slug:  item.id});
            }
        })
      },
      forceDeleteItem (item) {
        this.$refs.confirm.open('Usuń', 'Czy na pewno chcesz usunać użytkownika na stałe?', { color: 'error' }).then((confirm) => {
            if(confirm){
               this.$store.dispatch( 'forceDeleteUser', {slug:  item.id});
            }
        })
      },
      searchUsers(){
        if(this.search.length>2){
          const filterableHeaders = _.join(_.map(_.filter(this.headers,{'filterable':true}),'filterColumn'),';');
          this.$store.dispatch( 'searchUsers',{filterableHeaders:filterableHeaders,q:this.search});
        }
      },
      closePassword () {
        this.dialogPassword = false
      },
    },
  }
</script>


<style scoped>
.search{
      max-width: 250px;
}
</style>